<button mat-button [matMenuTriggerFor]="hiddenMenu">
  <img width="52" height="52" alt="Logo" src="assets/NE-Logo.png">
</button>

<mat-menu #hiddenMenu="matMenu">
  <button mat-menu-item (click)="navigate('Forwarder','/mask1')">
    <mat-icon>assignment</mat-icon>
    <span>Forwarder (Acceptance)</span>
  </button>
  <button mat-menu-item (click)="navigate('Forwarder','/mask3')">
    <mat-icon>assignment</mat-icon>
    <span>Forwarder (Warehouse Handling)</span>
  </button>
  <button mat-menu-item (click)="navigate('CHA','/mask2')">
    <mat-icon>assignment</mat-icon>
    <span>CHA (Acceptance)</span>
  </button>
  <button mat-menu-item (click)="navigate('CHA','/mask3')">
    <mat-icon>assignment</mat-icon>
    <span>CHA (Warehouse Handling)</span>
  </button>
  <button mat-menu-item (click)="navigate('GHA','/mask4')">
    <mat-icon>assignment</mat-icon>
    <span>GHA (Apron)</span>
  </button>
</mat-menu>